import { useSelector } from 'react-redux';

import { CommercialSubmenu } from './CommercialSubmenu';
import { selectCommercialLinks } from 'shared/selectors/commercialLinks';

export const CommercialSubmenuContainer = () => {
  const links = useSelector(selectCommercialLinks);

  return <CommercialSubmenu links={links} />;
};
